/**
 * Vendor Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Vendor { 
    creationDate?: string;
    lastUpdateDate?: string;
    createdBy?: string;
    lastUpdatedBy?: string;
    objectVersionNumber?: number;
    id?: number;
    vendorCode?: string;
    vendorName?: string;
    vendorEmail?: string;
    vendorPhone?: string;
    vendorAddress?: string;
    description?: string;
    deleteFlag?: boolean;
    country?: string;
    taxNumber?: string;
    vendorType?: string;
    billingCurrency?: string;
    paymentTerm?: string;
    paymentMethod?: string;
    bankAccountName?: string;
    bankAccountNumber?: string;
    bankName?: string;
    swiftCode?: string;
    category?: string;
    riskLevel?: string;
    status?: Vendor.StatusEnum;
    vendorPostingGroup?: string;
    generalBusinessPostingGroup?: string;
    vatBusinessPostingGroup?: string;
    invoiceDiscCode?: string;
}
export namespace Vendor {
    export const StatusEnum = {
        Draft: 'DRAFT',
        Reviewing: 'REVIEWING',
        Rejected: 'REJECTED',
        Pending: 'PENDING',
        Approved: 'APPROVED',
        Active: 'ACTIVE',
        Inactive: 'INACTIVE'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


